<template>
  <div>
    <v-col cols="12">
      <div class="group-form">
        <v-row>
          <v-col cols="12 py-0 pt-2 px-8">
            <h3>Chi tiết</h3>
          </v-col>
          <v-col cols="3" class="px-8 py-0 pt-2">
            <p class="text-bold mb-1" v-if="campaign.type === campaignTypePercentDiscount">Nhập % giảm giá*</p>
            <p class="text-bold mb-1" v-else>Nhập số tiền giảm*</p>
            <validation-provider
              v-slot="{ errors }"
              class="mb-2"
              :rules="{ required: true, min_value: 0, max: 10, alpha_num: true }"
              :name="campaign.type === campaignTypePercentDiscount ? 'Số % giảm giá':'Số tiền giảm'"
            >
              <v-text-field
                class="text-field text-field-number"
                :error-messages="errors"
                :clearable="true"
                :placeholder="campaign.type === campaignTypePercentDiscount ? 'Nhập % giảm giá' : 'Nhập số tiền giảm'"
                outlined
                dense
                type="number"
                :disabled="isDisableActive"
                v-model="campaign.promotionDiscount"
              ></v-text-field>
            </validation-provider>
          </v-col>

          <v-col cols="3" class="px-8 py-0 pt-2" v-if="campaign.type === campaignTypePercentDiscount">
            <p class="text-bold mb-1">Số tiền giảm tối đa</p>
            <validation-provider
              v-slot="{ errors }"
              class="mb-2"
              :rules="{ min_value: 0, alpha_num: true }"
              name="Số tiền giảm tối đa"
            >
              <v-text-field
                class="text-field text-field-number"
                :error-messages="errors"
                :clearable="true"
                placeholder="Nhập số tiền giảm tối đa"
                outlined
                dense
                type="number"
                :disabled="isDisableActive"
                v-model="campaign.numberOfAvailableOrder"
              ></v-text-field>
            </validation-provider>
          </v-col>

          <v-col cols="3" class="px-8 py-0 pt-2">
            <p class="text-bold mb-1">Số lượt tối đa/user</p>
            <validation-provider
              v-slot="{ errors }"
              class="mb-2"
              :rules="{ max: 10, min_value: 0, alpha_num: true }"
              name="Số lượt tối đa/user"
            >
              <v-text-field
                class="text-field text-field-number"
                :error-messages="errors"
                :clearable="true"
                placeholder="Nhập số lượt tối đa/user"
                outlined
                dense
                type="number"
                :disabled="isDisableActive"
                v-model="campaign.numberOfAvailableUser"
              ></v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
      </div>
    </v-col>
    <v-col cols="12">
      <div class="group-form">
        <v-row>
          <v-col cols="12 py-0 pt-2 px-8">
            <h3>Điều kiện áp dụng</h3>
          </v-col>
          <v-col cols="3" class="px-8 py-0 pt-2">
            <p class="text-bold mb-1">Giá trị đơn hàng tối thiểu*</p>
            <validation-provider
              v-slot="{ errors }"
              class="mb-2"
              :rules="{ required: true, min_value: 0, max: 10, alpha_num: true }"
              :name="'Giá trị đơn hàng tối thiểu'"
            >
              <v-text-field
                class="text-field text-field-number"
                :error-messages="errors"
                :clearable="true"
                :placeholder="[ campaignTypeOfApplicationSKU, campaignTypeOfApplicationCategory ].includes(campaign.typeOfApplication) ? 'Nhập g iá trị đơn hàng tối thiểu' : 'Nhập giá trị đơn hàng tối thiểu'"
                outlined
                dense
                type="number"
                :disabled="isDisableActive"
                v-model="campaign.minimumAmount"
              ></v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3" class="px-8 py-0 pt-2">
            <p class="text-bold mb-1">Loại hình áp dụng*</p>
            <validation-provider
              v-slot="{ errors }"
              class="mb-2"
              :rules="{ required: true }"
              name="Loại hình áp dụng"
            > 
              <v-select
                class="text-field"
                :error-messages="errors"
                :items="applyForms"
                item-value="id"
                item-text="name"
                :aLight="'right'"
                placeholder="Chọn loại hình áp dụng"
                attach
                outlined
                dense
                v-model="campaign.typeOfApplication"
                :disabled="!!campaign.id"
                @change="onChangeApplyForm"
                :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
              ></v-select>
            </validation-provider>
          </v-col>

          <v-col cols="3" class="px-8 py-0 pt-2" v-if="[2, 3, 4].includes(campaign.typeOfApplication)">
            <p class="text-bold mb-1">Hình thức sản phẩm*</p>
            <validation-provider
              v-slot="{ errors }"
              class="mb-2"
              name="Hình thức sản phẩm"
            > 
              <v-select
                class="text-field"
                :error-messages="errors"
                :items="typeOfProducts"
                item-value="id"
                item-text="name"
                :aLight="'right'"
                placeholder="Chọn hình thức sản phẩm"
                attach
                outlined
                dense
                v-model="campaign.typeOfProduct"
                :disabled="isDisableActive"
                :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
              ></v-select>
            </validation-provider>
          </v-col>
        </v-row>
        <BuList v-if="campaign.typeOfApplication === 4 && campaignBu.length" :pnlCodes="pnlCodes" :isDisableActive="isDisableActive" :isDisablePending="isDisablePending" :campaignBu="campaignBu" />
        <SkuList v-if="campaign.typeOfApplication === campaignTypeOfApplicationSKU" :skus="skus" :isDisableActive="isDisableActive" :isDisablePending="isDisablePending" />
        <CategoryList v-if="campaign.typeOfApplication === campaignTypeOfApplicationCategory" :isDisableActive="isDisableActive" :categoryCodes="categoryCodes" :isDisablePending="isDisablePending" />
      </div>
    </v-col>
    <div style="height: 200px;"></div>
  </div>
</template>

<script>
import {
  campaignTypeOfApplicationOrder,
  campaignTypeOfApplicationSKU,
  campaignTypeOfApplicationCategory,
  campaignTypePercentDiscount,
} from '../../../../helpers/constants';

import RepositoryFactory from '@/repositories/RepositoryFactory';
const ProductRepository = RepositoryFactory.get('product');

import SkuList from './SkuList.vue'
import CategoryList from './CategoryList.vue'
import BuList from './BuList.vue'

export default {
  props: {
    campaign: {
      type: Object,
      default: () => {},
    },
    readonly: { type: Boolean, default: false },
    applyForms: {
      type: Array,
      default: () => [],
    },
    pnlCodes: {
      type: Array,
      default: () => [],
    },
    categoryCodes: {
      type: Array,
      default: () => [],
    },
    isDisablePending: {
      type: Boolean,
      default: () => false,
    },
    isDisableActive: {
      type: Boolean,
      default: () => false,
    },
    campaignBu: {
      type: Array,
      default: () => [],
    },
    typeOfProducts: {
      type: Array,
      default: () => [],
    },
    skus: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    SkuList,
    CategoryList,
    BuList,
  },
  data() {
    return {
      skuList: [
        {
          resource: null,
          percent: null,
        }
      ],
      campaignTypeOfApplicationOrder,
      campaignTypeOfApplicationSKU,
      campaignTypeOfApplicationCategory,
      campaignTypePercentDiscount,
    };
  },
  computed: {
  },
  async created() {
  },
  beforeDestroy() {
  },
  methods: {
    onChangeApplyForm() {},
    addSku() {
      this.skuList.push({
        resource: null,
        percent: null,
      });
    },
    removeSku(item, index) {
      this.skuList.splice(index, 1);
    },
  },
  watch: {
  }
};
</script>
<style scoped lang="scss">
.text-bold {
  font-weight: bold;
}
.gr-action {
  position: relative;
  top: 0px;
  z-index: 10;

  .btn-search {
    background: #fff !important;
    min-width: 50px;
    color: #666666 !important;
  }

  .btn-create-product {
    background: #6587FF !important;
    color: #fff !important;
  }
}
.menu__custom {
  top: calc(20% - 75px) !important;
  left: 96% !important;
  transform: translateX(-96%) !important;
}
.btn-search {
  background: #6587FF !important;
}

.box-product-type {
  width: 300px;
}

.table-custom {
  th {
    background: #E7E8FF;
    border-left: 1px solid #fff;
  }
}
</style>

<style lang="scss">
.v-select-mini {
  .v-input__slot {
    min-height: 28px !important;
    height: 28px;
  }

  .v-text-field__details {
    display: none;
  }

  .v-input__append-inner {
    margin-top: 3px !important;
  }
}

.v-tab--active {
  color: #5E64FF !important;
}
.v-tabs-slider-wrapper {
  .v-tabs-slider {
    background-color: #5E64FF !important;
  }
}
.cursor-pointer {
  cursor: pointer;
}
</style>
